import {
  PageContainer,
  PageHeader,
  PageInfoTooltip,
  PageTitle,
  PageTitleGroup,
  PatientDevicesPanel,
} from "../shared";

/**
 * Cellular Devices admin page (EN-5166), migrated from the Retool
 * CellularDevices app.
 *
 * `page_CellularDevices`'s `$main` frame contained exactly one thing —
 * `<Module name="moduleDevices" patientId="" />` — so the page is a thin
 * wrapper around `PatientDevicesPanel` with no patient filter.
 *
 * That page also carried `queryAllFirmware` and the firmware create/update
 * queries, but they referenced widgets that do not exist on it
 * (`tableFirmware`, `formFirmware`, `modalAddUpdateFirmware`). They were dead
 * copy-paste, which is why Firmware stayed a separate page — see
 * retool-migration.md.
 */
export function AdminCellularDevices() {
  document.title = "Cellular devices - Admin";

  return (
    <PageContainer>
      <PageHeader>
        <PageTitleGroup>
          <PageTitle>Cellular devices</PageTitle>
          <PageInfoTooltip title="Cellular devices">
            Every device registered to a patient, across all wards.
            Disconnecting a device stops that patient&apos;s readings from it.
          </PageInfoTooltip>
        </PageTitleGroup>
      </PageHeader>

      {/* No panel title: the page is a thin wrapper and "Cellular
          devices" above already names this list. */}
      <PatientDevicesPanel title={null} />
    </PageContainer>
  );
}
